import { Component } from '@ecs/Component';

export class SniperAI implements Component {
  readonly type = 'SniperAI';

  constructor(
    public optimalRange: number = 250,
    public minRange: number = 220,
    public maxRange: number = 280,
    public lastPositionUpdate: number = 0,
    public isInPosition: boolean = false
  ) {}
}